import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faGithub, 
  faXTwitter,
  faInstagram
} from '@fortawesome/free-brands-svg-icons';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <h3>Digital Fig</h3>
            <p>Enterprise Web Solutions & Software Development</p>
          </div>
          
          <div className="footer-links">
            <h4>Navigation</h4>
            <ul>
              <li><a href="/#about">About Us</a></li>
              <li><a href="/#projects">Case Studies</a></li>
              <li><a href="/#skills">Our Services</a></li>
              <li><a href="/#contact">Contact Us</a></li>
            </ul>
          </div>
          
          <div className="footer-policies">
            <h4>Legal</h4>
            <ul>
              <li><a href="/privacy-policy">Privacy Policy</a></li>
              <li><a href="/cookie-policy">Cookie Policy</a></li>
              <li><a href="/terms-conditions">Terms & Conditions</a></li>
              <li><a href="/accessibility">Accessibility Statement</a></li>
              <li><a href="/refund-policy">Refund & Cancellation</a></li>
              <li><a href="/data-processing">Data Processing Agreement</a></li>
            </ul>
          </div>
          
          <div className="footer-social">
            <h4>Connect With Us</h4>
            <div className="social-icons">
              <a href="https://github.com/digital-fig" target="_blank" rel="noopener noreferrer" aria-label="GitHub Profile">
                <FontAwesomeIcon icon={faGithub} />
              </a>
              <a href="https://x.com/digitalf1g" target="_blank" rel="noopener noreferrer" aria-label="X (formerly Twitter) Profile">
                <FontAwesomeIcon icon={faXTwitter} />
              </a>
              <a href="https://instagram.com/digitalf1g" target="_blank" rel="noopener noreferrer" aria-label="Instagram Profile">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} Digital Fig. All Rights Reserved. Registered in England & Wales.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;